<div class="position-relative input-group">
    <span
            *ngIf="!!_innerValue" (click)="resetSearchString()"
            class="cursor-pointer link-secondary input-reset position-absolute">×</span>
    <input
            #searchInput
            class="form-control padding-right-w-reset"
            [disabled]="disabled"
            [ngClass]="{'border-radius-always': radiusAlways}"
            [placeholder]="placeholder"
            [(ngModel)]="innerValue"
    />
</div>
